import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import InstallDesktopTwoToneIcon from '@mui/icons-material/InstallDesktopTwoTone';
import '../Styles/StyleHome.css';
import Person2TwoToneIcon from '@mui/icons-material/Person2TwoTone';
import HomeIcon from '@mui/icons-material/Home';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Settings from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import Langue from './Langue';
import Data from '../Data/Data.json';
import MyMenu from '../Models/Menu';
import { useAuthHeader, useAuthUser, useSignOut } from '../Services/Auth/sessionAuth';
import Utilisateur from '../Models/Utilisateur';
import { Link, useNavigate } from 'react-router-dom';
import Mode from './Mode';
import { Book, Timelapse } from '@mui/icons-material';
import i18next from 'i18next';
import Fermer from "../Res/journeFerme.png";
import Ouvert from "../Res/journeOuverte.png";
import ParamsPicklist from '../Types/ParamsPicklist';
import { Crypter } from '../Functions/Security/Crypter';
import axios from 'axios';
import Swal from 'sweetalert2';

const drawerWidth = 240;
const options: Option[] = [
  { key: "p", name: "profil", link: "/user/profil" },
  { key: "s", name: "setting", link: "/setting" },
  { key: "l", name: "logout", link: "/login" },
]

interface Option {
  key: string,
  name: string,
  link: string
}


export function MenuAppbar() {
  //const user = JSON.parse(sessionStorage.getItem(Data.LocalVariable.user)+"")
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const navigate = useNavigate()
  const signOut = useSignOut()

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [isOpen, setIsOpen] = React.useState<boolean>();

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [openUserMenu, setOpenUserMenu] = React.useState(false);
  const userMenuRef = React.useRef<HTMLButtonElement>(null);
  const [date, setDate] = React.useState((new Date(user.datjour)).toLocaleDateString(i18next.language) + " " + (new Date()).toLocaleTimeString(i18next.language));


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleOpenUserMenu = () => {
    setOpenUserMenu(true);
  };

  const handleCloseUserMenu = (key: any, link?: string) => {
    if (key == "l") {
      let data = Crypter.encrypt(user.coduti);
      let config = {
        method: 'put',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.LogOut,
        headers: {
          'Authorization': authHeader(),
          'CipherUserCode': data,
        },
        //data: data
      };

      axios.request(config)
        .then((response) => {
          signOut()
          let res = JSON.parse(Crypter.decrypt(response.data))
          //console.log(res);

          // setLoading(false)
        })
        .catch((error) => {
          // setLoading(false)
          Swal.fire({
            title: "Déconnexion",
            text: error.message + "",
            icon: 'error',
            cancelButtonColor: "darkred",
            cancelButtonText: "Cloase",
          })
        });
    } else {
      if (link && link !== "backdropClick" && link !== "escapeKeyDown")
        navigate(link)
      setOpenUserMenu(false);
    }
  };

  React.useEffect(() => {
    if (user && user.codage) {
      loadStatutOfDay();
    }

    const clockInterval = setInterval(() => {
      if (user?.datjour) {
        setDate((new Date(user.datjour)).toLocaleDateString(i18next.language) + " " + (new Date()).toLocaleTimeString(i18next.language));
      }
    }, 1000);

    const statusInterval = setInterval(() => {
      if (user && user.codage) {
        loadStatutOfDay();
      }
    }, 30000);

    return () => {
      clearInterval(clockInterval);
      clearInterval(statusInterval);
    };
  }, [user?.datjour, user?.codage, i18next.language]);

  function loadStatutOfDay() {
   // let search: ParamsPicklist = { CodeAgence: '', Table: "DATGEN", Colonne1: "CODAGE", Colonne2: "CDETAT", Init: user.codage, Colagence: '', Choix: 33 }
    let search: ParamsPicklist = { CodeAgence: '', Table: "DATGEN", Colonne1: "CODAGE", Colonne2: "CDETAT", Init: user.codage, Colagence: '', Choix: 35 }

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(search))
      }
    };
    axios(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          if (res.StatutCode == 200) {
            let datas = res.Result.Table[0];
            if (datas.CDETAT == '50') {
              setIsOpen(true)
            }
            else {
              setIsOpen(false)
            }
          }
        }
      }).catch(() => { })
  }

  return (
    <>
      <AppBar
        id='AppBar'
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },

        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{
              mr: 2, display: { sm: 'none' }, backgroundColor: 'darkred', width: 20,
              height: 41
            }}
          >
            <MenuIcon />
          </IconButton>
          <Stack direction="row" spacing={2}>

            <Button className='buttap' size='small' startIcon={<Person2TwoToneIcon sx={{ color: 'white' }} />} ><p className='textbap'>{user.coduti + " - " + user.nomuti}</p></Button>
            <Button className='buttap' size='small' startIcon={<InstallDesktopTwoToneIcon sx={{ color: 'white' }} />} ><p className='textbap'>{user.group}</p></Button>
            <Button onClick={() => { navigate("/") }} className='buttap' size='small' startIcon={<HomeIcon sx={{ color: 'white' }} />} ><p className='textbap'>{user.agence}</p></Button>
            <Button className='buttap' size='small' startIcon={<Timelapse sx={{ color: 'white' }} />} ><p className='textbap'>{date}</p></Button>

            {isOpen != null ? <Button className='buttap' size='small' startIcon={<img width={30} src={isOpen ? Ouvert : Fermer} />} ><p className='textbap'>{"Journée comptable " + (isOpen ? "ouverte" : "Fermé")}</p></Button> : ""}
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>

            <Langue />
            <Mode />

            <IconButton
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
            >
              <Badge badgeContent={3} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <IconButton
              ref={userMenuRef}
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-haspopup="true"
              aria-controls={openUserMenu ? 'menu-appbar' : undefined}
              aria-expanded={openUserMenu}
              color="inherit"
              onClick={handleOpenUserMenu}
            >
              <Avatar sx={{ border: 'solid' }} alt="Cindy Baker" src={user.photo} />
            </IconButton>
            <Popper
              open={openUserMenu}
              anchorEl={userMenuRef.current}
              placement="bottom-end"
              transition
              sx={{ zIndex: (theme) => theme.zIndex.modal }}
            >
              {({ TransitionProps }) => (
                <Grow {...TransitionProps} style={{ transformOrigin: 'top right' }}>
                  <Paper
                    sx={{
                      borderRadius: '12px',
                      boxShadow: '0 8px 30px rgba(0,0,0,0.18)',
                      overflow: 'hidden',
                      mt: 0.5,
                      minWidth: 240
                    }}
                  >
                    <ClickAwayListener onClickAway={() => setOpenUserMenu(false)}>
                      <Box>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            px: 2,
                            py: 1.5,
                            background: 'linear-gradient(135deg, #1565c0 0%, #1e88e5 100%)',
                            color: '#fff'
                          }}
                        >
                          <Avatar
                            src={user.photo}
                            alt={user.nomuti}
                            sx={{ width: 40, height: 40, border: '2px solid rgba(255,255,255,0.6)' }}
                          />
                          <Box sx={{ overflow: 'hidden' }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, lineHeight: 1.2 }} noWrap>
                              {user.nomuti}
                            </Typography>
                            <Typography variant="caption" sx={{ opacity: 0.85 }} noWrap>
                              {user.coduti}{user.agence ? ` · ${user.agence}` : ''}
                            </Typography>
                          </Box>
                        </Box>
                        <MenuList
                          autoFocusItem={openUserMenu}
                          id="menu-appbar"
                          onKeyDown={(e) => { if (e.key === 'Escape') setOpenUserMenu(false); }}
                          sx={{ py: 0.5 }}
                        >
                          {options.filter(o => o.key !== 'l').map((option: Option) => (
                            <MenuItem
                              key={option.key}
                              onClick={() => { handleCloseUserMenu(option.key, option.link) }}
                              sx={{
                                px: 2,
                                py: 1,
                                mx: 0.5,
                                borderRadius: '8px',
                                '&:hover': { backgroundColor: 'action.hover' }
                              }}
                            >
                              <ListItemIcon sx={{ minWidth: 32 }}>
                                {option.key === 's'
                                  ? <Settings fontSize="small" />
                                  : <Person2TwoToneIcon fontSize="small" />}
                              </ListItemIcon>
                              <ListItemText primary={option.name} />
                            </MenuItem>
                          ))}
                          <Divider sx={{ my: 0.5 }} />
                          {options.filter(o => o.key === 'l').map((option: Option) => (
                            <MenuItem
                              key={option.key}
                              onClick={() => { handleCloseUserMenu(option.key, option.link) }}
                              sx={{
                                px: 2,
                                py: 1,
                                mx: 0.5,
                                borderRadius: '8px',
                                color: 'error.main',
                                '&:hover': { backgroundColor: 'error.lighter' }
                              }}
                            >
                              <ListItemIcon sx={{ minWidth: 32, color: 'error.main' }}>
                                <LogoutIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText primary={option.name} />
                            </MenuItem>
                          ))}
                        </MenuList>
                      </Box>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Box>
        </Toolbar>
      </AppBar>
    </>


  )
}